'use memo';

import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';
import { featureFlags } from '@/lib/env';

/**
 * Item Ledger（品目台帳）追加フローのレイアウト。
 *
 * `_list.tsx` / `$itemId/_layout.tsx` と同様、ITEM_LEDGER feature flag が
 * 無効な環境では 404 にする。一覧の beforeLoad を経由しない直接アクセス
 * （/item-ledger/add, /item-ledger/add/completed）でも、無効化された
 * 品目台帳の追加UI・作成操作が露出しないようにするため。
 */
export const Route = createFileRoute('/_staff/item-ledger/add')({
  beforeLoad: () => {
    if (!featureFlags.check('ITEM_LEDGER')) {
      throw notFound();
    }
  },
  component: () => <Outlet />
});